
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acheter/guide/investissement-immobilier",
      function () {
        return require("private-next-pages/acheter/guide/investissement-immobilier/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acheter/guide/investissement-immobilier"])
      });
    }
  